import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ButtonModule,
  FormFieldModule,
  FitTextModule,
  DefaultImageModule,
} from '@shared/components/games';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { MatrixControllerComponent } from './matrix-controller/matrix-controller.component';
import { MatrixCorrectAnswerPreviewComponent } from './matrix-preview/matrix-answer-preview/matrix-answer-preview.component';
import { MatrixExamplePreviewComponent } from './matrix-preview/matrix-example-preview/matrix-example-preview.component';
import { MatrixParametersPreviewComponent } from './matrix-preview/matrix-parameters-preview/matrix-parameters-preview.component';
import { MatrixUserAnswerPreviewComponent } from './matrix-preview/matrix-user-answer-preview/matrix-user-answer-preview.component';
import { MatrixSettingsComponent } from './matrix-settings/matrix-settings.component';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { MathGamesSharedModule } from '@games/games-shared/math-games-shared.module';

@NgModule({
  declarations: [
    MatrixControllerComponent,
    MatrixSettingsComponent,
    MatrixCorrectAnswerPreviewComponent,
    MatrixExamplePreviewComponent,
    MatrixParametersPreviewComponent,
    MatrixUserAnswerPreviewComponent,
  ],
  exports: [
    MatrixControllerComponent,
    MatrixSettingsComponent,
    MatrixCorrectAnswerPreviewComponent,
    MatrixExamplePreviewComponent,
    MatrixParametersPreviewComponent,
    MatrixUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    FitTextModule,
    NgSelectModule,
    DefaultImageModule,
    FormFieldModule,
    MathGamesSharedModule,
  ],
})
export class MatrixModule {}
